import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getSlackWorkspacesQueryKey } from 'hooks/queries/notifications/useGetSlackWorkspaces';

type TestSlackWorkspaceParams = {
  workspaceId: string;
  channels: string[];
  name?: string;
};

export const useTestSlackWorkspace = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ workspaceId, name, channels }: TestSlackWorkspaceParams) => {
      return apiClient.notifications.testSlackWorkspace({
        id: workspaceId,
        config: {
          name,
          channels,
        },
      });
    },
    onSuccess: () => {
      queryClient
        .invalidateQueries({ queryKey: getSlackWorkspacesQueryKey() })
        .then(() => {
          notify.success('Test notification sent successfully');
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
